import { render, staticRenderFns } from "./ProductUpdate.vue?vue&type=template&id=0e9ea812"
import script from "./ProductUpdate.vue?vue&type=script&lang=ts"
export * from "./ProductUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports